// extracted by mini-css-extract-plugin
export default {"OneNew":"OneNew_OneNew__7ZkU6","OneNewContainer":"OneNew_OneNewContainer__5uMEi"};